// Column names of the marker CSV. Three places share them: the bulk import
// (BulkCsvUploadModal) reads them, the xlsx templates under public/ carry them
// in row 1, and the dashboard's CSV export writes them. Keep them in step.

export const BASE_COLUMNS = [
  'type', 'title', 'descriptionGerman', 'descriptionEnglish',
  'musicGenre', 'image', 'instagramName', 'address', 'latitude', 'longitude',
  'entryPrice', 'minAge', 'dressCode', 'drinkPriceIndicator', 'specialType',
];

export const EVENT_COLUMNS = [
  'eventDate', 'startTime', 'endTime',
  'ticketUrl', 'hostCode',
  'boxOfficePrice', 'boxOfficeAvailability', 'hasAwarenessTeam',
];

export const WEEKDAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

/** mondayOpen, mondayClose, …, sundayClose */
export const CLUB_COLUMNS = WEEKDAY_KEYS.flatMap((day) => [`${day}Open`, `${day}Close`]);

/** artist1Name, artist1Instagram, artist1SpotifyId, … for `slots` acts. */
export const artistColumns = (slots) => Array.from({ length: slots }, (_, i) => [
  `artist${i + 1}Name`, `artist${i + 1}Instagram`, `artist${i + 1}SpotifyId`,
]).flat();

/** The event template names three acts. */
export const TEMPLATE_ARTIST_SLOTS = 3;
